module.exports = __webpack_public_path__ + "static/media/recommended.385ec014.png";